import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, firestore } from "./firebaseConfig";
import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
import UploadContract from "./pages/UploadContract";
import ContractList from "./pages/ContractList";
import ContractDetail from "./pages/ContractDetail";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ManageMembers from "./pages/ManageMembers";
import BillingPage from "./pages/BillingPage";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Footer from "./components/Footer";
import LandingPage from "./pages/LandingPage";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import AIContractReview from "./pages/blog/AiContractReview";
import StartupContractManagement from "./pages/blog/StartupContractManagement";
import BlogIndex from './pages/BlogIndex';

const App = () => {
  const [user, loading] = useAuthState(auth);
  const [subscribed, setSubscribed] = useState(false)

  useEffect(() => {
    if (user) {
      const fetchUser = async () => {
        // const userQuery = query(collection(firestore, "users"), where("uid", "==", user.uid));
        const userQuery = doc(firestore, "users", user.uid)
        const userSnapshot = await getDoc(userQuery);
        // console.log(userSnapshot)
        if (userSnapshot.exists()) {
          // console.log('data')
          const userData = userSnapshot.data();
          const isSubscribed = !!userData.subscriptionActive;

          // Now check how many contracts this user/org has
          const orgId = userData.orgId;
          const contractsQuery = query(
            collection(firestore, "contracts"),
            where("orgId", "==", orgId)
          );
          const contractsSnapshot = await getDocs(contractsQuery);
          const contractCount = contractsSnapshot.size;

          // Only mark as needing subscription if they have 2+ contracts
          setSubscribed(isSubscribed || contractCount < 2);
        }
      };
      fetchUser();
    }
  }, [user]);

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true" ||
    (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches)
  );

  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
    document.documentElement.classList.toggle("dark", darkMode);
  }, [darkMode]);

  if (loading) return <div className="text-center mt-10">Loading...</div>;

  return (
    <Router>
      <div className={`min-h-screen ${darkMode ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-900"}`}>
        <Navbar user={user} darkMode={darkMode} setDarkMode={setDarkMode} />
        <div className="container mx-auto p-6">
          <Routes>
            <Route path="/" element={user ? subscribed ? <ContractList /> : <BillingPage /> : <LandingPage />} />
            {/* Mange route for subscription */}
            <Route path="/billing" element={<ProtectedRoute element={<BillingPage />} />} />
            <Route path="/success" element={<ProtectedRoute element={<Success />} />} />
            <Route path="/cancel" element={<ProtectedRoute element={<Cancel />} />} />
            {/* Manage routes for application */}
            {/* Blog Posts */}
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/ai-contract-review" element={<AIContractReview />} />
            <Route path="/blog/startup-contract-strategy" element={<StartupContractManagement />} />

            <Route path="/upload" element={<ProtectedRoute element={<UploadContract />} />} />
            <Route path="/manage-members" element={<ProtectedRoute element={<ManageMembers />} />} />
            <Route path="/contracts/:id" element={<ProtectedRoute element={<ContractDetail />} />} />
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
            <Route path="/signup" element={!user ? <SignUp /> : <Navigate to="/" />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
